import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBJumbotron, MDBTable, MDBTableBody, MDBTableHead, MDBIcon, MDBDataTable } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Descriptions   } from 'antd';
import { api, URL } from '../../api';
import Swal from 'sweetalert2/dist/sweetalert2.js'

var md5 = require('md5');
var xlsx = require("xlsx");

export default class Modelteacherregisterfile extends Component {


    constructor(props) {
              super(props);
      this.state = {
        modal: false,
       
        Curriculumopen_Full_Name_TH:'',
        Curriculumopen_Full_Name_EN:'',
        Curriculumopen_CH:'',

        Curriculumopen_ID:'',//
        Studentcb_ID:'',
        Citizen:'',

        studentlist:[],


        Educationlevel:[],
        prefix:[],
        province:[],
        district:[],
        subdistrict:[],


        Studentcb_ID:'',

        Studentcb_Citizen_ID:'',
        Studentcb_PNAME:'',
        Studentcb_NAME:'',
        Studentcb_LASTNAME:'',
        Studentcb_ADDRESS:'',
        Studentcb_PROVINCE:'',
        Studentcb_DISTRICT:'',
        Studentcb_SUBDISTRICT:'',
        Studentcb_ZIPCODE:'', 
        Studentcb_TEL:'',
        Studentcb_EMAIL:'',
        Studentcb_Education_LEVEL:'',
        Studentcb_SCHOOL:'',
        Studentcb_DB:'',
        Studentcb_STATUS:'',
        Univ_ID:'',
        Edu_ID:'',  

        datastuKamphaengphet:[],
        idcuriculum:'',
        loadding:false,
      }

//this.handleSubmit = this.handleSubmit.bind(this);
        this.getregisterCurriculum = this.getregisterCurriculum.bind(this);
        this.getprefix = this.getprefix.bind(this);
        this.getprovince = this.getprovince.bind(this);
        this.onChangeprovince = this.onChangeprovince.bind(this);
        this.onChangedistrict = this.onChangedistrict.bind(this);
        this.getzipcode = this.getzipcode.bind(this);
        this.onTextChange = this.onTextChange.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onChange2 = this.onChange2.bind(this);
        this.getEducationlevel = this.getEducationlevel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggle = this.toggle.bind(this);
        this.cleardata = this.cleardata.bind(this);
         this.readUploadFile = this.readUploadFile.bind(this);

    }


            toggle = () => {
                this.setState({
                modal: !this.state.modal
                });
                this.setState({ Citizen:this.props.Citizen})
                this.getregisterCurriculum();
                this.setState({ idcuriculum:this.props.idcuriculum}) 
            }



            getregisterCurriculum() {
                setTimeout(() => {
                   //ภายใน
                   api.get('index/getregisterCurriculum/'+this.props.Curriculumopen_ID)
                   .then(res => {
                   //  console.log(res.data);
                     const Numlist = res.data.filter( ({ Studentcb_Citizen_ID }) => Studentcb_Citizen_ID === this.props.Citizen );
                   //  this.setState({ bankname: res.data, loading: false })
                     this.setState({ Numlist : Numlist})
                   }) 
                 }, 0);
            }

            cleardata() {
              this.setState({
                 Studentcb_Citizen_ID:'',
                 Studentcb_NAME:'',
                 Studentcb_LASTNAME:'',
                 Studentcb_DB:'',
                 Studentcb_ADDRESS:'',
                 Studentcb_ZIPCODE:'', 
                 Studentcb_TEL:'',
                 Studentcb_EMAIL:'',
                 Studentcb_SCHOOL:'',
                })            
            }


            onTextChange = (e) => {
                this.setState({ [e.target.name]: e.target.value })
              }


            getEducationlevel() {
                 api.get('index/getEducationlevel',
                         //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                         {headers: {
                           // Authorization: 'Bearer ' + localStorage.getItem('myData')
                         }
                         })
                         //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                         .then(res => {
                             // console.log(res.data[0].id)
                            //  console.log(res.data)
                           // const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                          //  console.log(Course)
                             const Educationlevel = res.data;
                             this.setState({ Educationlevel });
                         })  
           }

            getprefix() {
                api.get('index/getprefix',
                    {headers: {
                      // Authorization: 'Bearer ' + localStorage.getItem('myData')
                    }  })
                    .then(res => {
                       // console.log(res.data[0].id)
                     //  console.log(res.data)
                      // const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                     //  console.log(Course)
                        const prefix = res.data;
                        this.setState({ prefix });
                  }) 
           }



           getprovince() {
            api.get('index/getprovince',
                {headers: {
                  // Authorization: 'Bearer ' + localStorage.getItem('myData')
                }  })
                .then(res => {
                   // console.log(res.data[0].id)
                 //  console.log(res.data)
                  // const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                 //  console.log(Course)
                    const province = res.data;
                    this.setState({ province });
              }) 
           }



         //คำนำหน้า
           onChange(value) {
            console.log(`selected ${value}`);
            this.setState({ Studentcb_PNAME: value })
          }

          onChange2(value) {
            console.log(`selected ${value}`);
            this.setState({ Studentcb_Education_LEVEL: value })
          }
          //จังหวัด
          onChangeprovince(value) {
            console.log(`selected ${value}`);
            this.setState({ Studentcb_PROVINCE: value })

                  api.get('index/getdistrict/'+value,
                  {headers: {
                    // Authorization: 'Bearer ' + localStorage.getItem('myData')
                  }  })
                  .then(res => {
                      const district = res.data;
                      this.setState({ district });
                  }) 
          }

          //อำเภอ
          onChangedistrict(value) {
            console.log(`selected ${value}`);
            this.setState({ Studentcb_DISTRICT: value })

                  api.get('index/getsubdistrict/'+value,
                  {headers: {
                    // Authorization: 'Bearer ' + localStorage.getItem('myData')
                  }  })
                  .then(res => {
                 
                      const subdistrict = res.data;
                      this.setState({ subdistrict });
                }) 
          }
          
          //    รหัสไปรษณีย์
          getzipcode(value) {
            console.log(`selected ${value}`);
            this.setState({ Studentcb_SUBDISTRICT: value })

                  api.get('index/getzipcode/'+value,
                  {headers: {
                    // Authorization: 'Bearer ' + localStorage.getItem('myData')
                  }  })
                  .then(res => {
                     console.log(res.data[0].ZIPCODE)
                
                     const fd = res.data[0].ZIPCODE;
                     this.setState({ Studentcb_ZIPCODE: fd});
                }) 
          }


          
          onBlur() {
            console.log('blur');
          }
          
           onFocus() {
            console.log('focus');
          }
          
           onSearch(val) {
            console.log('search:', val);
           }


           handleSubmit() {
            // alert('A name was submitted: ' + this.state.value);
            
            this.setState({ loadding: true});
            // api.get('index/checkregister/'+this.state.Studentcb_Citizen_ID,
            // {headers: {
            // }  })
            // .then(res => {
            //   if (res.data.length === 0) {


                
             //   setTimeout(() => {
                //  const form = Tablelist

                for (let index = 0; index < this.state.datastuKamphaengphet.length; index++) {
                            const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                            datafrm.append("Studentcb_Citizen_ID", this.state.datastuKamphaengphet[index].Studentcb_Citizen_ID);
                            datafrm.append("Studentcb_PNAME", this.state.datastuKamphaengphet[index].Studentcb_PNAME);
                            datafrm.append("Studentcb_NAME", this.state.datastuKamphaengphet[index].Studentcb_NAME);
                            datafrm.append("Studentcb_LASTNAME", this.state.datastuKamphaengphet[index].Studentcb_LASTNAME);
                            datafrm.append("Studentcb_DB", this.state.datastuKamphaengphet[index].Studentcb_DB);
                            datafrm.append("Studentcb_DBMD5", md5(this.state.datastuKamphaengphet[index].Studentcb_DB));
                            datafrm.append("Studentcb_ADDRESS", this.state.Studentcb_ADDRESS);
                            datafrm.append("Studentcb_PROVINCE", this.state.Studentcb_PROVINCE);
                            datafrm.append("Studentcb_DISTRICT", this.state.Studentcb_DISTRICT);
                            datafrm.append("Studentcb_SUBDISTRICT", this.state.Studentcb_SUBDISTRICT);
                            datafrm.append("Studentcb_ZIPCODE", this.state.Studentcb_ZIPCODE);
                            datafrm.append("Studentcb_TEL", this.state.datastuKamphaengphet[index].Studentcb_TEL);
                            datafrm.append("Studentcb_EMAIL", this.state.datastuKamphaengphet[index].Studentcb_EMAIL);
                            datafrm.append("Studentcb_Education_LEVEL", this.state.Studentcb_Education_LEVEL);
                            datafrm.append("Studentcb_SCHOOL", this.state.Studentcb_SCHOOL);
                            // datafrm.append("Univ_ID", this.state.Univ_ID);
                            
                        Axios.post("https://mua.kpru.ac.th/FrontEnd_creditbank/index/AddStudentRegister/",datafrm,{
                            headers: {
                                'content-type': 'multipart/form-data'
                            }
                        })
                        
                        .then(res => {
                                console.log(res);
                                if (this.state.datastuKamphaengphet.length === index+1) {


                                    for (let indexs = 0; indexs < this.state.datastuKamphaengphet.length; indexs++) {
                                //  alert("บันทึกสำเร็จ")
                                        api.get('index/studentsearchforadd/'+this.state.datastuKamphaengphet[indexs].Studentcb_Citizen_ID,{
                                            headers: {
                                            
                                            }
                                            })
                                            .then(res => {
                                                if (res.data.length !== 0) {

                                                 
                                                        const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                                                        datafrm.append("Curriculumopen_ID", this.props.idcuriculum);
                                                        datafrm.append("Studentcb_ID", res.data[0].Studentcb_ID);
                                                        datafrm.append("Studentcb_Citizen_ID", this.state.datastuKamphaengphet[indexs].Studentcb_Citizen_ID);
                                                        
                                                        api.post("index/AddregisterCurriculum/",datafrm,{
                                                            headers: {
                                                                'content-type': 'multipart/form-data'
                                                            }
                                                        })
                                                
                                                       .then(res => {
                                                        if (res.status === 200 && this.state.datastuKamphaengphet.length === indexs+1) {
                                                                    Swal.fire({
                                                                        title: 'ลงทะเบียนและเพิ่มผู้เรียนสำเร็จ',
                                                                        icon: 'success',
                                                                        confirmButtonText: 'ตกลง',
                                                                    // cancelButtonText: 'No, keep it'
                                                                    }).then((result) => {
                                                                         this.setState({ loadding: false});
                                                                        if (result.isConfirmed) {
                                                                            //  Swal.fire('Saved!', '', 'success')
                                                                            // this.props.stulist();
                                                                           
                                                                            this.toggle();
                                                                             this.props.stulist();
                                                                            } else if (result.isDenied) {
                                                                             // Swal.fire('Changes are not saved', '', 'info')
                                                                            }
                                                                    })
                                                                }
                                                        })
                                    
                                                      
                                               

                                                }
                                            }) 
                                        }//ปิดloopที่2



                                }
                        })

                 }


                    //  this.getteacherforcurriculum();
                   // this.toggle()
                  //  this.props.getclassroom()
             //  }, 4000); 
   
            //   }else{
            //               Swal.fire({
            //                 title: 'เลขประจำตัวประชาชนนี้ได้ลงทะเบียนแล้ว',
            //                 text: "กรุณาตรวจสอบอีกครั้ง",
            //                 icon: 'warning',
                          
            //                 confirmButtonText: 'ตกลง',
                          
            //               }).then((result) => {
                          
            //               })
            //   }
            // }) 
        //  window.location.href = '/Register'
        //this.props.updateat();
        //this.getExpert() 
          }



           




            componentDidMount() {

                //const { id_send } = this.props.id_send
                //console.log(this.props.Curriculumopen_ID);
                this.setState({ Curriculumopen_ID:this.props.Curriculumopen_ID}) 
                this.setState({ Curriculumopen_Full_Name_TH:this.props.Curriculumopen_Full_Name_TH}) 
               // this.setState({ Curriculumopen_Full_Name_TH:this.props.Curriculumopen_Full_Name_TH})
               // this.setState({ Citizen:this.props.Citizen})
               
              
                          api.get('index/getCurriculumstudentlist/'+this.props.Curriculumopen_ID,
                          //  Axios.get(`https://git.kpru.ac.th/FrontEnd_creditbank/index/getteacheruniv/`+localStorage.getItem('Univ_ID'),
                          //  Axios.get(`https://mis.kpru.ac.th/api/EmployeeInOrg/000`,
                          {headers: {
                          // Authorization: 'Bearer ' + localStorage.getItem('myData')
                          }
                          })
                          //  axios.defaults.headers.common['Authorization'] = `Bearer` + localStorage.getItem('myData') 
                          .then(res => {
                          // console.log(res.data[0].id)
                          //  console.log(res.data)
                          //  const Course = res.data.filter( ({ Course_Year }) => Course_Year >= this.state.year );
                          //  console.log(Course)
                     
                             const studentlist = res.data;
                              this.setState({ studentlist });
                           }) 
         
             this.getprefix();    
             this.getprovince();
             this.getEducationlevel();
                }


                readUploadFile = (e) => {
                    e.preventDefault();
                    if (e.target.files) {
                        const reader = new FileReader();
                        reader.onload = (e) => {
                            const data = e.target.result;
                            const workbook = xlsx.read(data, { type: "array" });
                            const sheetName = workbook.SheetNames[0];
                            const worksheet = workbook.Sheets[sheetName];
                            const json = xlsx.utils.sheet_to_json(worksheet);
                         //   console.log(json);
                         const myArray = json.map((i) => ({
                            Studentcb_Citizen_ID: i.เลขประจำตัวประชาชน,
                            Studentcb_PNAME: i.คำนำหน้า,
                            Studentcb_NAME: i.ชื่อ,
                            Studentcb_LASTNAME: i.นามสกุล,
                            Studentcb_TEL: i.เบอร์โทร,
                            Studentcb_EMAIL: i.อีเมลล์,
                            Studentcb_DB: i.วันเดือนปีเกิด

                         }));




                          this.setState({ datastuKamphaengphet: myArray })
                
                        };
                        reader.readAsArrayBuffer(e.target.files[0]);
                    }
                }

                


    render() {
       // console.log(this.state.Numlist.length)
     //  console.log(this.state.Studentcb_Citizen_ID)
      // console.log(this.state.Studentcb_PNAME)
     //  console.log(this.state.Studentcb_NAME)
     //  console.log(this.state.Studentcb_LASTNAME)
     //  console.log(this.state.Studentcb_DB)
     //  console.log(md5(this.state.Studentcb_DB))
      // console.log(this.state.Studentcb_ADDRESS)
      // console.log(this.state.Studentcb_PROVINCE)
      // console.log(this.state.Studentcb_DISTRICT)
      // console.log(this.state.Studentcb_SUBDISTRICT)
      // console.log(this.state.Studentcb_ZIPCODE)
 
      // console.log(this.state.Studentcb_TEL)
      // console.log(this.state.Studentcb_EMAIL)
      // console.log(this.state.Studentcb_Education_LEVEL)
     // console.log(this.state.Studentcb_SCHOOL)



       //ชุดตาราง
             const data = {
               columns: [
                 {
                   label: 'ลำดับ',
                   field: 'name',
                   sort: 'name',
                   width: 150
                 },
                 {
                    label: 'เลขประจำตัวประชาชน',
                    field: 'customers_citizent',
                    sort: 'customers_citizent',
                    width: 270
                  },
                 {
                   label: 'คำนำหน้า',
                   field: 'Studentcb_PNAME',
                   sort: 'Studentcb_PNAME',
                   width: 270
                 },
                 {
                   label: 'ชื่อ',
                   field: 'Studentcb_NAME',
                   sort: 'Studentcb_NAME',
                   width: 200
                 },
                 {
                   label: 'นามสกุล',
                   field: 'Studentcb_LASTNAME',
                   sort: 'Studentcb_LASTNAME',
                   width: 100
                 },
                 {
                   label: 'อีเมลล์',
                   field: 'Studentcb_EMAIL',
                   sort: 'Studentcb_EMAIL',
                   width: 150
                 },
                 {
                    label: 'วันเดือนปีเกิด',
                    field: 'Studentcb_DB',
                    sort: 'Studentcb_DB',
                    width: 150
                  },
                 {
                   label: 'เบอร์โทร',
                   field: 'Studentcb_TEL',
                   sort: 'Studentcb_TEL',
                   width: 150
                 }
               ],
     
               rows: [...this.state.datastuKamphaengphet.map((data, i) => (
                 {
                    name: <>{i+1}</>,
                    customers_citizent: <>{data.Studentcb_Citizen_ID}</>,
                    Studentcb_PNAME: <>{data.Studentcb_PNAME}</>,
                    Studentcb_NAME: <>{data.Studentcb_NAME}</>,
                    Studentcb_LASTNAME: <>{data.Studentcb_LASTNAME}</>,
                    Studentcb_EMAIL: <>{data.Studentcb_EMAIL}</>,
                    Studentcb_DB: <>{data.Studentcb_DB}</>,
                    Studentcb_TEL: <>{data.Studentcb_TEL}</>,
                   
                    random: <h5 searchvalue={data.Studentcb_NAME} >tourist <span className="badge badge-danger">narrow</span></h5>
               
                 }
                ))]
               
           };
                 const persons = <MDBDataTable
                // searching ={true}
                 searchLabel="ค้นหา ชื่อ,นามกสุล,เบอร์โทร"
                 striped
                 bordered
                 small 
                 entries={20}
                // entriesOptions={["10", "20"]}
                 order={["age", "desc"]}
                 data={data}
                 entriesLabel="จำนวนที่แสดง "
                 infoLabel= {["แสดง", "ถึง", "จากทั้งหมด", "รายการ"]}
                 paginationLabel={["ย้อนกลับ", "ถัดไป"]}
                 responsive 
                 sortRows={['random']}
           />





     console.log(this.state.datastuKamphaengphet)

        return (
            <>
               
                    <MDBBtn onClick={this.toggle} color="indigo" >ลงทะเบียนผู้เรียนใหม่ แบบแนบไฟล์</MDBBtn>

                    <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
                    <MDBModalHeader toggle={this.toggle}><MDBIcon icon="address-book" /> ลงทะเบียนผู้เรียน (สำหรับผู้สอนลงทะเบียนให้) </MDBModalHeader>
                   
                        <MDBModalBody>
                            {/* {this.props.Citizen} */}
                             {/* <h5>หลักสูตร {this.state.Curriculumopen_Full_Name_TH}</h5>   */}


                             <MDBJumbotron >
  
                                        <MDBContainer className="text-left">
                                        <div className='text-center'>
                                             <MDBBtn outline  href="https://e-student.kpru.ac.th/creditbank/creditbankpdf/ฟอร์มอัพโหลดนักเรียน.xlsx"
                                                                        target="_blank">ดาวน์โหลดฟอร์มสำหรับอัพโหลด</MDBBtn> 
                                        </div>
                                       

                                        <h2 className="display-5 deep-purple-text text-center mt-2">ลงทะเบียน {this.state.Course_Name_TH}</h2>

                                        <form  >
                                        <div id="pdfdiv">

                                        {/* <div className="form-group">
                                            <label htmlFor="example2">เลขประจำตัวประชาชน 13 หลัก</label>
                                            <Input showCount maxLength={13} minLength={13} placeholder="เลขประจำตัวประชาชน 13 หลัก" value={this.state.Studentcb_Citizen_ID} name="Studentcb_Citizen_ID" onChange={this.onTextChange} required  />
                                           
                                        </div> */}

                                        {/* <div className="form-group">
                                            <label htmlFor="example2">คำนำหน้า</label>
                                          
                                            <div>
                                            <Select
                                            showSearch
                                            style={{ width: "100%" }}
                                            placeholder="--เลือกอาจารย์--"
                                            optionFilterProp="children"
                                            onChange={this.onChange}
                                            onFocus={this.onFocus}
                                            onBlur={this.onBlur}
                                            onSearch={this.onSearch}
                                            filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            >
                                           

                                            {this.state.prefix.map((prefix,index )  => 
                                            <option value={prefix.PREFIX_NAME_ID}>{prefix.FULLNAME}</option>
                                            )}
                                            </Select>

                                            </div>
                                        </div> */}

                                        {/* <div className="form-group">
                                              <label htmlFor="example2">ชื่อ</label>
                                              <Input placeholder="ชื่อ" value={this.state.Studentcb_NAME} name="Studentcb_NAME" onChange={this.onTextChange} required  />
                                        
                                        </div> */}

                                        {/* <div className="form-group">
                                           <label htmlFor="example2">นามสกุล</label>
                                           <Input placeholder="นามสกุล" value={this.state.Studentcb_LASTNAME} name="Studentcb_LASTNAME" onChange={this.onTextChange} required  />
                                           
                                        </div> */}


                                        {/* <div className="form-group">
                                          <label htmlFor="example2">วันเดือนปีเกิด</label>
                                          <Input placeholder="ตัวอย่าง 09/10/64" value={this.state.Studentcb_DB} name="Studentcb_DB" onChange={this.onTextChange} required  />
                                        </div> */}


                                        <div className="form-group">
                                          <label htmlFor="example2">ที่อยู่ สถานศึกษา</label>
                                          <Input placeholder="ที่อยู่ สถานศึกษา" value={this.state.Studentcb_ADDRESS} name="Studentcb_ADDRESS" onChange={this.onTextChange} required  />
                                          {/* <input type="text" id="example2"  placeholder="ที่อยู่" className="form-control form-control-md" value={this.state.Studentcb_ADDRESS} name="Studentcb_ADDRESS"  onChange={this.onTextChange}  required /> */}
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="example2">จังหวัด</label>
                                            {/* <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_ID} onChange={this.handleChange4} /> */}
                                            <div>
                                                <Select
                                                showSearch
                                                style={{ width: "100%" }}
                                                placeholder="--จังหวัด--"
                                                optionFilterProp="children"
                                                onChange={this.onChangeprovince}
                                                onFocus={this.onFocus}
                                                onBlur={this.onBlur}
                                                onSearch={this.onSearch}
                                                filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                                >
                                                {/* <Option value="jack">Jack</Option>
                                                <Option value="lucy">Lucy</Option>
                                                <Option value="tom">Tom</Option> */}

                                                {this.state.province.map((province,index )  => 
                                                <option value={province.PROVINCE_ID}>{province.PROVINCE_NAME_TH}</option>
                                                )}
                                                </Select>

                                            </div>
                                        </div>

                                        <div className="form-group">
                                                    <label htmlFor="example2">อำเภอ</label>
                                                    {/* <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_ID} onChange={this.handleChange4} /> */}
                                                    <div>
                                                    <Select
                                                    showSearch
                                                    style={{ width: "100%" }}
                                                    placeholder="--อำเภอ--"
                                                    optionFilterProp="children"
                                                    onChange={this.onChangedistrict}
                                                    onFocus={this.onFocus}
                                                    onBlur={this.onBlur}
                                                    onSearch={this.onSearch}
                                                    filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    >
                                                    {/* <Option value="jack">Jack</Option>
                                                    <Option value="lucy">Lucy</Option>
                                                    <Option value="tom">Tom</Option> */}

                                                    {this.state.district.map((district,index )  => 
                                                    <option value={district.DISTRICT_ID}>{district.DISTRICT_NAME_TH}</option>
                                                    )}
                                                    </Select>

                                                    </div>
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="example2">ตำบล</label>
                                            {/* <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_ID} onChange={this.handleChange4} /> */}
                                            <div>
                                            <Select
                                            showSearch
                                            style={{ width: "100%" }}
                                            placeholder="--ตำบล--"
                                            optionFilterProp="children"
                                            onChange={this.getzipcode}
                                            onFocus={this.onFocus}
                                            onBlur={this.onBlur}
                                            onSearch={this.onSearch}
                                            filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            >
                                            {/* <Option value="jack">Jack</Option>
                                            <Option value="lucy">Lucy</Option>
                                            <Option value="tom">Tom</Option> */}

                                            {this.state.subdistrict.map((subdistrict,index )  => 
                                            <option value={subdistrict.SUB_DISTRICT_ID}>{subdistrict.SUB_DISTRICT_NAME_TH}</option>
                                            )}
                                            </Select>

                                            </div>
                                        </div>

                                        <div className="form-group">
                                        <label htmlFor="example2">รหัสไปรษณีย์</label>
                                        <Input placeholder="รหัสไปรษณีย์" value={this.state.Studentcb_ZIPCODE} name="Studentcb_ZIPCODE" onChange={this.onTextChange} required  />
                                        {/* <input type="text" id="example2" placeholder="เบอร์โทร" className="form-control form-control-md" value={this.state.Studentcb_TEL} name="Studentcb_TEL"  onChange={this.onTextChange}  required /> */}
                                        </div>

                                        {/* <div className="form-group">
                                        <label htmlFor="example2">เบอร์โทร</label>
                                        <Input placeholder="เบอร์โทร" value={this.state.Studentcb_TEL} name="Studentcb_TEL" onChange={this.onTextChange} required  />
                                       
                                        </div> */}

                                        {/* <div className="form-group">
                                        <label htmlFor="example2">อีเมลล์</label>
                                        <Input placeholder="อีเมลล์"  type="email" value={this.state.Studentcb_EMAIL} name="Studentcb_EMAIL" onChange={this.onTextChange} required  />
                                       
                                        </div> */}

                                      

                                        <div className="form-group">
                                        <label htmlFor="example2">ระดับการศึกษา</label>
                                        {/* <input type="text" id="example2" className="form-control form-control-md" value={this.state.Course_ID} onChange={this.handleChange4} /> */}
                                        <div>
                                        <Select
                                        showSearch
                                        style={{ width: "100%" }}
                                        placeholder="-- เลือกระดับการศึกษา --"
                                        optionFilterProp="children"
                                        onChange={this.onChange2}
                                        onFocus={this.onFocus}
                                        onBlur={this.onBlur}
                                        onSearch={this.onSearch}
                                        filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        >
                                        {/* <Option value="jack">Jack</Option>
                                        <Option value="lucy">Lucy</Option>
                                        <Option value="tom">Tom</Option> */}

                                        {this.state.Educationlevel.map((data,index )  => 
                                        <option value={data.Edu_ID}>{data.Edu_name}</option>
                                        )}
                                        </Select>

                                        </div>
                                        </div>


                                        <div className="form-group">
                                        <label htmlFor="example2">โรงเรียน/สถาบัน</label>
                                        <Input placeholder="โรงเรียน/สถาบัน" value={this.state.Studentcb_SCHOOL} name="Studentcb_SCHOOL" onChange={this.onTextChange} required  />
                                        {/* <input type="text" id="example2" placeholder="โรงเรียน/สถาบัน" className="form-control form-control-md" value={this.state.Studentcb_SCHOOL} name="Studentcb_SCHOOL"  onChange={this.onTextChange}  required /> */}
                                        </div>

                                         <label htmlFor="upload">Upload File</label><br/>
                                            <input
                                                type="file"
                                                name="upload"
                                                id="upload"
                                                onChange={this.readUploadFile}
                                            />
                                         <h4 className='text-center'>ตัวอย่างรายชื่อ</h4>

{persons} 

{this.state.loadding === true ?<>
<div className='text-center'>
    <div className="spinner-border " role="status">
        <span className="sr-only">Loading...</span>
      </div>
</div>
    
</>:<>

  <p className="text-center"><MDBBtn color="secondary" onClick={this.handleSubmit} >ลงทะเบียน</MDBBtn></p>
</>}
                                      

                                        </div>

                                        </form>

                                        </MDBContainer>
                                        </MDBJumbotron>

                    
                        </MDBModalBody>
                        <MDBModalFooter>
                        <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                        {/* <MDBBtn color="primary">Save changes</MDBBtn> */}
                        </MDBModalFooter>
                    </MDBModal>
               
            </>
        )
    }
}
